module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_04_6NW26_1SC_GED.c7c7c02c.png";